import { ConversationEmbed, EmbedEvent, MessagePayload } from '@thoughtspot/visual-embed-sdk'
import { useEffect } from 'react'
import { logError } from '../../services/error/logger'
import EmbeddedContent from '../../components/EmbeddedContent'
import { useOrgConfig } from '../../services/orgConfigContext/utils'
import { HIDDEN_CREATE_VISUAL_ACTIONS } from '../../constants'
import useLocationRerenderNavItem from '../../hooks/useLocationRerenderNavItem'

export const embedId = 'embed-ask-ai-headcount'

/**
 * Ask AI page accessible by the URL: /ask-ai
 * This page corresponds to the Spotter section of the Homepage under Insights
 */
 
const AskAI = () => {
  const { dataSourceGUID } = useOrgConfig()
  const locationKey = useLocationRerenderNavItem()

  useEffect(() => {
    const conversationEmbed = new ConversationEmbed(`#${embedId}`, {
      worksheetId: dataSourceGUID,
      hiddenActions:HIDDEN_CREATE_VISUAL_ACTIONS,
    })

    void conversationEmbed
    .on(EmbedEvent.Error, (messagePayload: MessagePayload) => {
      const embedError = new Error(`Ask AI: ${JSON.stringify(messagePayload)}`)
      logError(embedError)
    })
    .render()
  }, [dataSourceGUID, locationKey])
  return (
    <EmbeddedContent
      id={embedId}
      testId={embedId}
    />
  )
}

export default AskAI
